import f from 'odata-filter-builder';
import { transformODataResponse } from 'utilities/query';
import templateUrl from './ingredient-autocomplete.html';

export default {
  templateUrl,
  bindings: {
    ingredientType: '@',
    labelText: '@',
    companyId: '<',
    searchText: '<',
    selectedIngredient: '<',
    searchDisplayProperty: '@',
    onIngredientSelected: '&'
  },
  controller: class IngredientAutocomplete {
    constructor($log, EventEmitter, IngredientService) {
      'ngInject';

      Object.assign(this, {
        $log,
        EventEmitter,
        IngredientService
      });
    }

    searchIngredients(name) {
      if (!this.ingredientType) {
        this.$log.error('Required ingredientType parameter not supplied for ingredient autocomplete!');
        return Promise.resolve(false);
      }

      if (this.ingredientType === 'system') {
        return this.searchSystemIngredients(name);
      }

      return this.searchUserIngredients(name);
    }

    searchUserIngredients(name) {
      return this.IngredientService.searchUserIngredients({
        ...this.IngredientService.getDefaultUserIngredientQuery(),
        filter: f().and(x => x.contains('UserIngredientName', name))
      }).then(r => transformODataResponse(r).Data);
    }

    searchSystemIngredients(name) {
      return this.IngredientService.searchSystemIngredients({
        ...this.IngredientService.getDefaultSystemIngredientQuery(),
        filter: f().and(x => x.contains('SystemIngredientName', name))
      }).then(r => transformODataResponse(r).Data);
    }

    selectedIngredientChanged(selectedIngredient) {
      this.onIngredientSelected(
        this.EventEmitter({
          selectedIngredient
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/autocomplete/ingredient/ingredient-autocomplete.component.js